<app-mit-dialog
    [formGroup]="formGroup" 
    [dialogFields]="dialogFields" 
    [callback]="callback"
    >
</app-mit-dialog>